import React, { forwardRef } from 'react';
import { withStyles, makeStyles } from '@mui/styles';;
import DefaultButton from '@mui/material/Button';
import { COLORS } from '../../constants/colors.js';
import clsx from 'clsx';

const SecondaryButton = forwardRef(
  (
    {
      title,
      keyboardShortcut,
      buttonSize = 'medium',
      executeClick,
      customFontSize,
      customMargin,
      customHeight,
      customWidth,
      buttonType,
      borderWidth,
      disabled,
      backgroundColor = COLORS.white,
      className,
      ...props
    },
    ref,
  ) => {
    var button_height;
    var font_size;
    if (buttonSize === 'small') {
      button_height = '28px';
      font_size = '11px';
    } else if (buttonSize === 'medium') {
      button_height = '36px';
      font_size = '12px';
    } else if (buttonSize === 'large') {
      button_height = '52px';
      font_size = '13px';
    }

    var btn_color = COLORS.cta_blue;
    var btn_color_hover = COLORS.hover_blue;
    if (buttonType == 'alert') {
      var btn_color = COLORS.app_red;
      var btn_color_hover = COLORS.app_red_hover;
    }

    const styles = makeStyles({
      root: {
        color: btn_color,
        fontSize: customFontSize ? customFontSize : font_size,
        fontWeight: 500,
        fontFamily: 'Work Sans',
        float: 'left',
        width: customWidth ? customWidth : '100%',
        borderRadius: '6px',
        height: customHeight ? customHeight : button_height,
        margin: customMargin ? customMargin : '0px',
        padding: '6px 12px',
        lineHeight: 1.5,
        textTransform: 'none',
        backgroundColor: backgroundColor,
        border: `${borderWidth == 'thin' ? 1.4 : 2}px solid ${disabled ? '#B3B3B3' : btn_color
          }`,
        '&:hover': {
          backgroundColor: backgroundColor ? backgroundColor : btn_color_hover,
        },
      },
    });
    const classes = styles();

    return (
      <DefaultButton
        ref={ref}
        variant="contained"
        onClick={executeClick}
        className={clsx(className, classes.root)}
        disabled={disabled ? disabled : false}
        disableElevation
        {...props}
      >
        {title}{' '}
        <p style={{ color: '#95ACB7', fontSize: '10px' }}>
          {' '}
          {keyboardShortcut ? keyboardShortcut : ''}
        </p>
      </DefaultButton>
    );
  },
);

export default SecondaryButton;
